import { array, bool, func, number, object, string } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as MigrationSettingsActions from '../actions/MigrationSettingsActions';
import * as MigrationProcessActions from '../actions/MigrationProcessActions';
import SlideoutHeader from 'ps-components/Slideout/Header/SlideoutHeader';
import SlideoutFooter from 'ps-components/Slideout/Footer/SlideoutFooter';
import SlideoutFooterStandardButtons from 'ps-components/Slideout/Footer/SlideoutFooterStandardButtons';
import SlideoutBody from 'ps-components/Slideout/Body/SlideoutBody';
import ProgressStatusOverlay from 'ps-components/ProgressStatus/ProgressStatusOverlay';
import SlideoutSubmitSuccess from 'ps-components/Slideout/SubmitSuccess/SlideoutSubmitSuccess';
import SlideoutError from 'ps-components/Slideout/Error/SlideoutError';
import MigrationSettingsContent from './MigrationSettingsContent';
import DataCutPrioritySlideoutPanel from '../DataCutPriority/DataCutPrioritySlideoutPanel';
import { MIGRATION_STATUS } from '../reducers/MigrationProcessReducer';
import './MigrationSettingsSlideout.scss';
import { showSlideout } from 'ps-components/Slideout/SlideoutReducer';
import { SLIDEOUTS } from '../../Slideout/Slideouts';
import { CONTACT_SUPPORT_MESSAGE } from '../../../lib/constants';

export class MigrationSettingsSlideout extends Component {
  static propTypes = {
    reviewingDataCuts: bool,
    getSelectedSurveys: func,
    goBackToSettings: func,
    closeSlideout: func,
    slideout: object,
    orgId: number,
    groupId: number,
    curSurveyYear: number,
    newSurveyYear: number,
    selectedSurveys: array,
    showDataCut: bool,
    shouldShowSlideout: bool,
    dataCutOption: string,
    typeOfReview: string,
    autoReviewOption: string,
    reviewDataCuts: func,
    toggleDataCutOption: func,
    setDataCutOption: func,
    setAutoReviewOption: func,
    setTypeOfReview: func,
    setPriorityBasedDataCuts: func,
    startMigrationProcess: func,
    endMigrationProcessError: func,
    endMigrationProcessSuccess: func,
    endMigrationTimeout: func,
    resetMigrationProcess: func,
    migrationStatus: string,
    history: object,
    runMigration: func,
    gridStore: object,
    hideSlideout: func,
    showSlideout: func
  };

  constructor(props) {
    super(props);
    this.legacyMigrate = this.legacyMigrate.bind(this);
    this.renderSlideoutBody = this.renderSlideoutBody.bind(this);
    this.contactSupport = this.contactSupport.bind(this);
  }

  componentDidMount() {
    const {
      selectedSurveys,
      getSelectedSurveys,
      curSurveyYear,
      newSurveyYear,
      shouldShowSlideout,
      resetMigrationProcess,
      hideSlideout
    } = this.props;
    resetMigrationProcess();
    getSelectedSurveys(curSurveyYear, newSurveyYear);
    if (!selectedSurveys || shouldShowSlideout === null) {
      hideSlideout();
    }
  }

  componentDidUpdate(prevProps) {
    const {
      slideout,
      getSelectedSurveys,
      closeSlideout,
      curSurveyYear,
      newSurveyYear,
      resetMigrationProcess
    } = this.props;
    if (slideout.open && !prevProps.slideout.open) {
      resetMigrationProcess();
      getSelectedSurveys(curSurveyYear, newSurveyYear);
    } else if (!slideout.open && prevProps.slideout.open && prevProps.shouldShowSlideout) {
      closeSlideout();
    }
  }

  legacyMigrate() {
    const {
      selectedSurveys,
      curSurveyYear,
      newSurveyYear,
      setPriorityBasedDataCuts,
      runMigration,
      showDataCut,
      endMigrationProcessError,
      endMigrationProcessSuccess,
      endMigrationTimeout,
      typeOfReview,
      autoReviewOption,
      dataCutOption,
      gridStore
    } = this.props;

    this.props.slideout.conditionalSlideout = false;
    (showDataCut
      ? dataCutOption === 'exceptions'
        ? setPriorityBasedDataCuts(selectedSurveys, curSurveyYear, true)
        : setPriorityBasedDataCuts(selectedSurveys, curSurveyYear, false)
      : Promise.resolve()
    )
      .then(() => {
        // If manual review do not preserve matches, otherwise preserve matches
        // by passing 1 for current weighting or 2 for zero weighting
        const preserveMatches = typeOfReview === 'manual' ? 0 : autoReviewOption === 'current' ? 1 : 2;
        return runMigration(selectedSurveys, curSurveyYear, newSurveyYear, preserveMatches);
      })
      .then(() => {
        this.props.slideout.conditionalSlideout = true;
        // Legacy callback to reload data, REMOVE when landing page is redone
        gridStore.load({
          callback: () => {
            endMigrationProcessSuccess();
          }
        });
      })
      .catch(e => {
        this.props.slideout.conditionalSlideout = true;
        if (e?.message === MigrationProcessActions.TIMEOUT_MESSAGE) {
          endMigrationTimeout();
        } else {
          endMigrationProcessError();
        }
      });
  }

  contactSupport() {
    const { showSlideout } = this.props;
    showSlideout(SLIDEOUTS.CONTACT_SUPPORT_SLIDEOUT);
  }

  renderReviewDataCuts = () => {
    return (
      <DataCutPrioritySlideoutPanel
        //this.props will change once implementation is done on the DataCutPrioritySlideoutPanel
        {...this.props}
        goBack={this.props.goBackToSettings}
        backText="Return to Migration Settings"
      />
    );
  };

  renderSlideoutBody = numOfSurveys => {
    const { migrationStatus, resetMigrationProcess } = this.props;
    switch (migrationStatus) {
      case MIGRATION_STATUS.STARTED:
        return (
          <ProgressStatusOverlay
            inProgress={true}
            primaryText={'Migrating ' + numOfSurveys + ' survey(s)...'}
            submitSuccessDetails="This might take a moment"
          />
        );
      case MIGRATION_STATUS.ERROR:
        return (
          <SlideoutError className="migration-process__error" doClose={resetMigrationProcess}>
            <h4>An error occured during migration. Please try again.</h4>
            <div className="migration-process-error__instructions">
              {CONTACT_SUPPORT_MESSAGE}
            </div>
          </SlideoutError>
        );
      case MIGRATION_STATUS.TIMED_OUT:
        return (
          <SlideoutError className="migration-process__error" doClose={resetMigrationProcess}>
            <h4>The migration has been running for over 25 minutes.</h4>
            <div className="migration-process-error__instructions">
              If you have not yet received a confirmation email, the migration may still be running.&nbsp; Depending on
              factors such as number of users on MarketPay, load on the system,&nbsp; and number of concurrent
              migrations being run, the migration may take longer than usual.&nbsp; If you do not receive a confirmation
              email within an hour of starting the migration,&nbsp; please refresh the migration page and confirm which
              surveys have been migrated and&nbsp; contact support via the Help icon on the navigation menu.
            </div>
          </SlideoutError>
        );
    }
  };

  renderMigrationSettings = () => {
    const {
      showDataCut,
      selectedSurveys,
      migrationStatus,
      reviewDataCuts,
      dataCutOption,
      setDataCutOption,
      toggleDataCutOption,
      typeOfReview,
      autoReviewOption,
      setAutoReviewOption,
      setTypeOfReview,
      resetMigrationProcess,
      hideSlideout,
      dataCutOptionsSaved,
      noExceptions
    } = this.props;

    if (migrationStatus === MIGRATION_STATUS.SUCCESS)
      return (
        <SlideoutSubmitSuccess
          actionFunction={hideSlideout}
          actionText="Done"
          submitSuccessDetails="Go back to all surveys to see the migration summary of each survey."
          submitSuccessTitle={selectedSurveys.length + ' Survey(s) have been migrated!'}
          closeAction={resetMigrationProcess}
        />
      );
    return (
      <React.Fragment>
        <SlideoutHeader
          title="Review Migration Settings"
          subtitle={'Migrate ' + selectedSurveys.length + ' Surveys'}
          doClose={hideSlideout}
        />
        <SlideoutBody>
          {this.renderSlideoutBody(selectedSurveys.length)}
          <MigrationSettingsContent
            dataCutOption={dataCutOption}
            showDataCut={showDataCut}
            dataCutOptionsSaved={dataCutOptionsSaved}
            noExceptions={noExceptions}
            setDataCutOption={setDataCutOption}
            toggleDataCutOption={toggleDataCutOption}
            setAutoReviewOption={setAutoReviewOption}
            setTypeOfReview={setTypeOfReview}
            reviewDataCuts={reviewDataCuts}
            typeOfReview={typeOfReview}
            autoReviewOption={autoReviewOption}
          />
        </SlideoutBody>
        <SlideoutFooter isBoxShadowTheme={true}>
          <SlideoutFooterStandardButtons
            applyText={'Apply & Migrate ' + selectedSurveys.length + ' Surveys'}
            doApply={this.legacyMigrate}
            doCancel={hideSlideout}
          />
        </SlideoutFooter>
      </React.Fragment>
    );
  };

  render() {
    const { shouldShowSlideout } = this.props;
    if (shouldShowSlideout) {
      const renderInner = this.props.reviewingDataCuts ? this.renderReviewDataCuts : this.renderMigrationSettings;
      return <div className="migration-settings">{renderInner()}</div>;
    } else {
      return <div></div>;
    }
  }
}

const mapStateToProps = ({ surveyMigration, session }) => {
  return {
    curSurveyYear: surveyMigration.migrationSettings.curSurveyYear,
    newSurveyYear: surveyMigration.migrationSettings.newSurveyYear,
    gridStore: surveyMigration.migrationSettings.gridStore,
    selectedSurveys: surveyMigration.migrationSettings.selectedSurveys,
    dataCutOptionsSaved: surveyMigration.migrationSettings.dataCutOptionsSaved,
    noExceptions: surveyMigration.migrationSettings.noExceptions,
    showDataCut: surveyMigration.migrationSettings.showDataCut,
    dataCutOption: surveyMigration.migrationSettings.dataCutOption,
    reviewingDataCuts: surveyMigration.migrationSettings.reviewingDataCuts,
    typeOfReview: surveyMigration.migrationSettings.typeOfReview,
    autoReviewOption: surveyMigration.migrationSettings.autoReviewOption,
    shouldShowSlideout: surveyMigration.migrationSettings.shouldShowSlideout,
    orgId: parseInt(session.organization.id),
    groupId: parseInt(session.group.id),
    migrationStatus: surveyMigration.migrationProcess.migrationStatus
  };
};

const actions = {
  ...MigrationSettingsActions,
  ...MigrationProcessActions,
  showSlideout
};

export default connect(mapStateToProps, actions)(withRouter(MigrationSettingsSlideout));
